import {
    ToggleButton,
    ToggleButtonGroup,
    Stack,
    Tooltip,
} from '@mui/material';

import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop';
import VerticalAlignCenterIcon from '@mui/icons-material/VerticalAlignCenter';
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';

import {HorizontalAlign, VerticalAlign, LabelAlignment} from "../../../../common/apis/LabelAlignment";

import {_transl} from "../../../../store/localization/TranslMessasge";
import {StyleSettingsTranslationKey} from "./StyleSettingsTranslationKey";

type Props = {
    value: LabelAlignment;
    onChange: (value: LabelAlignment) => void;
    disabled?: boolean,
    showHorizontal?: boolean,
    showVertical?: boolean,
};

export function LabelAlignmentControl({value, onChange, disabled, showHorizontal = true, showVertical = false}: Readonly<Props>) {
    return (
            <Stack direction="row" spacing={2}>
                {showHorizontal &&
                    <ToggleButtonGroup
                            exclusive
                            size="small"
                            value={value.horizontal}
                            onChange={(event, horizontal) =>
                                    horizontal && onChange({...value, horizontal: horizontal})
                            }
                            disabled={disabled}
                    >
                        <ToggleButton value={HorizontalAlign.LEFT}>
                            <Tooltip title={_transl(StyleSettingsTranslationKey.ALIGN_LEFT)}>
                                <FormatAlignLeftIcon/>
                            </Tooltip>
                        </ToggleButton>
                        <ToggleButton value={HorizontalAlign.CENTER}>
                            <Tooltip title={_transl(StyleSettingsTranslationKey.ALIGN_CENTER)}>
                                <FormatAlignCenterIcon/>
                            </Tooltip>
                        </ToggleButton>
                        <ToggleButton value={HorizontalAlign.RIGHT}>
                            <Tooltip title={_transl(StyleSettingsTranslationKey.ALIGN_RIGHT)}>
                                <FormatAlignRightIcon/>
                            </Tooltip>
                        </ToggleButton>
                    </ToggleButtonGroup>
                }
                {showVertical &&
                    <ToggleButtonGroup
                            exclusive
                            size="small"
                            value={value.vertical}
                            onChange={(event, vertical) =>
                                    vertical && onChange({...value, vertical: vertical})
                            }
                            disabled={disabled}
                    >
                        <ToggleButton value={VerticalAlign.TOP}>
                            <Tooltip title={_transl(StyleSettingsTranslationKey.ALIGN_TOP)}>
                                <VerticalAlignTopIcon/>
                            </Tooltip>
                        </ToggleButton>
                        <ToggleButton value={VerticalAlign.MIDDLE}>
                            <Tooltip title={_transl(StyleSettingsTranslationKey.ALIGN_MIDDLE)}>
                                <VerticalAlignCenterIcon/>
                            </Tooltip>
                        </ToggleButton>
                        <ToggleButton value={VerticalAlign.BOTTOM}>
                            <Tooltip title={_transl(StyleSettingsTranslationKey.ALIGN_BOTTOM)}>
                                <VerticalAlignBottomIcon/>
                            </Tooltip>
                        </ToggleButton>
                    </ToggleButtonGroup>
                }
            </Stack>
    );
}
